

    <div class="bw-filter-results-header nsw-filters__title">
        <a [tabindex]="0">Refine search by type or area</a>
    </div>
    <form [formGroup]="filterForm" (ngSubmit)="onFilterSubmit($event)" #formRef class="nsw-form filter-form">    
        <div class="flex-container">
            <div class="filter-scroll" #filterScrollArea>

                <div class="nsw-filters__item">
                    <fieldset class="nsw-form__fieldset">
                        <legend>
                            <span class="nsw-form__legend">Filter by type:</span>
                        </legend>
                        <div formArrayName="site_types">							
                            <ng-container *ngFor="let site_type of site_types.controls; let i=index">
                                <input (change)="onSiteTypeChange($event)" [formControlName]="i"
                                    class="nsw-form__checkbox-input" type="checkbox" name="filters-site_types"
                                    value="{{getSiteTypeLabel(i)}}" id="filters-site_types-{{i}}">
                                <label class="nsw-form__checkbox-label"
                                    for="filters-site_types-{{i}}">{{getSiteTypeLabel(i)}}</label>
                            </ng-container>
                        </div>
                    </fieldset>
                </div>
                
                <div class="nsw-form__group">
                    <fieldset class="nsw-form__fieldset">
                        <legend style="float: inherit">
                            <span class="nsw-form__legend">Filter by area:</span>
                        </legend>
                        <input (change)="areaModeChanged($event)" class="nsw-form__radio-input" type="radio"
                            name="form-radio-1" id="form-radio-1-b" checked value="region">
                        <label class="nsw-form__radio-label" for="form-radio-1-b">Region</label>
                        <input (change)="areaModeChanged($event)" class="nsw-form__radio-input" type="radio"
                            name="form-radio-1" id="form-radio-1-a" value="council">
                        <label class="nsw-form__radio-label" for="form-radio-1-a">Council</label>
                        <input (change)="areaModeChanged($event)" class="nsw-form__radio-input" type="radio"
                            name="form-radio-1" id="form-radio-1-c" value="beachSites">
                        <label class="nsw-form__radio-label" for="form-radio-1-c">Sites</label>
                    </fieldset>
                </div>
                
                <div class="nsw-filters__item" style="border:none">
                    <fieldset class="nsw-form__fieldset">
                        <legend>
                            <span class="nsw-form__legend">Filter by keyword:</span>
                        </legend>
                        <div class="nsw-form__input-group nsw-form__input-group--icon"
                            style="padding-right: 16px;">
                            <label class="sr-only" for="form-input-group-icon-2">Search</label>
                            <input formControlName="keywordFilter" (input)="onAreaSearchUpdated($event)"
                                class="nsw-form__input" type="text" id="form-input-group-icon-2"
                                name="form-input-group-icon-2" value="">
                            <button class="nsw-button nsw-button--white nsw-button--flex">
                                <span
                                    class="material-icons nsw-material-icons" focusable="false"
                                    aria-hidden="true" alt="search site by region or council">search</span>
                            </button>
                        </div>
                    </fieldset>
                </div>                          
                
                <div class="list-container" #listContainerRef>
                   <ng-container *ngIf="areaMode === 'region'" formArrayName="regions" >
                        <ng-container *ngFor="let reg of this.regions.controls; let regionIdx=index">
                            <ng-container *ngIf="showArea(regionIdx)" [formGroupName]="regionIdx">
                                <div class="nsw-form__input-group nsw-form__input-group--icon item">
                                    <a  
                                        type="button"
                                        class="expand-collapse-button"
                                        
                                        (click)="onExpandButtonClicked($event, 'Region', regionIdx)" [tabIndex]="0">
                                        <span class="material-icons nsw-material-icons" focusable="false" aria-hidden="true">
                                            {{!isExpanded('Region', regionIdx) ? 'chevron_right' : 'expand_more'}}
                                        </span>
                                    </a>
                                    <input formControlName="region" (change)="onRegionChange(regionIdx)"
                                        class="nsw-form__checkbox-input" type="checkbox" name="filters-regions"
                                        value="{{getRegionLabel(regionIdx)}}" id="filters-regions-{{regionIdx}}">
                                    <label class="nsw-form__checkbox-label"
                                        for="filters-regions-{{regionIdx}}">{{getRegionLabel(regionIdx)}}</label>
                                </div> 
                                
                                <div class="nested-list">
                                    <ng-container formArrayName="sites" *ngIf="isExpanded('Region', regionIdx)">
                                        <ng-container
                                            *ngFor="let site of getRegionSites(regionIdx).controls; let siteIdx=index">
                                            <ng-container *ngIf="showSite(regionIdx,siteIdx)">
                                                <input (change)="onRegionSiteChange(regionIdx,siteIdx)"
                                                    [formControlName]="siteIdx" class="nsw-form__checkbox-input"
                                                    type="checkbox" name="filters-sites-{{regionIdx}}-{{siteIdx}}"
                                                    value="{{getRegionSiteNames(siteIdx,regionIdx)}}"
                                                    id="filters-sites-{{regionIdx}}-{{siteIdx}}">
                                                <label
                                                    class="nsw-form__checkbox-label"
                                                    for="filters-sites-{{regionIdx}}-{{siteIdx}}">
                                                    {{getRegionSiteNames(siteIdx,regionIdx)}}
                                                </label>
                                            </ng-container>
                                        </ng-container>
                                    </ng-container>
                                </div>
                                
                            </ng-container>
                        </ng-container>
                    </ng-container>

                    <ng-container *ngIf="areaMode === 'council'" formArrayName="councils" >
                        <ng-container *ngFor="let cnl of this.councils.controls; let councilIdx=index">
                            <ng-container *ngIf="showArea(councilIdx)" [formGroupName]="councilIdx">
                                <div class="nsw-form__input-group nsw-form__input-group--icon item">                               
                                    <a  
                                        type="button"                                      
                                        class="expand-collapse-button" 
                                        (click)="onExpandButtonClicked($event, 'Council', councilIdx)" [tabIndex]="0">
                                        <span class="material-icons nsw-material-icons" focusable="false" aria-hidden="true">
                                            {{!isExpanded('Council', councilIdx) ? 'chevron_right' : 'expand_more'}}
                                        </span>
                                    </a> 
                                    <input class="nsw-form__checkbox-input" formControlName="council" 
                                        (change)="onCouncilChange(councilIdx)"
                                        type="checkbox" name="filters-councils"
                                        value="{{getCouncilLabel(councilIdx)}}" id="filters-councils-{{councilIdx}}"/>
                                    <label class="nsw-form__checkbox-label no-margin-top"
                                        for="filters-councils-{{councilIdx}}">{{getCouncilLabel(councilIdx)}}
                                    </label>  
                                </div>
                                
                                <div class="nested-list">
                                    <ng-container formArrayName="sites" *ngIf="isExpanded('Council', councilIdx)">
                                        <ng-container
                                            *ngFor="let site of getCouncilSites(councilIdx).controls; let siteIdx=index">
                                            <ng-container *ngIf="showSite(councilIdx,siteIdx)">
                                                <input (change)="onCouncilSiteChange(councilIdx,siteIdx)"
                                                    [formControlName]="siteIdx" class="nsw-form__checkbox-input"
                                                    type="checkbox" name="filters-sites-{{councilIdx}}-{{siteIdx}}"
                                                    value="{{getCouncilSiteNames(siteIdx,councilIdx)}}"
                                                    id="filters-sites-{{councilIdx}}-{{siteIdx}}">
                                                <label
                                                    class="nsw-form__checkbox-label"
                                                    for="filters-sites-{{councilIdx}}-{{siteIdx}}">
                                                    {{getCouncilSiteNames(siteIdx,councilIdx)}}
                                                </label>
                                            </ng-container>
                                        </ng-container>
                                    </ng-container>
                                </div>
                                
                            </ng-container>
                        </ng-container>    
                    </ng-container>

                    <ng-container *ngIf="areaMode === 'beachSites'" formArrayName="sitesArray">
                        <ng-container *ngFor="let cnl of this.sitesArray.controls; let siteIndex=index">
                            <ng-container *ngIf="showArea(siteIndex)">
                                <input class="nsw-form__checkbox-input" [formControlName]="siteIndex" 
                                    (change)="onBeachSiteChange(siteIndex)"
                                    type="checkbox" name="filters-beachSites"
                                    value="getBeachSiteLabel(siteIndex)" id="filters-beachSites-{{siteIndex}}"/>
                                <label class="nsw-form__checkbox-label no-margin-top"
                                    for="filters-beachSites-{{siteIndex}}">{{getBeachSiteLabel(siteIndex)}}
                                </label>
                            </ng-container>
                        </ng-container>
                    </ng-container>


                </div>
                
                <div *ngIf="noResultsFound()" class="nsw-results-bar__info">Sorry, no results found for your filter</div>

            </div>
            <div class="nsw-filters__accept bw-submit-area" #submitRef>
                <button data-bs-toggle="offcanvas" data-bs-target="#filterResultsPanel" [disabled]="!isFilterUpdated()" type="submit"
                    class="nsw-button nsw-button--dark nsw-button--full-width" style="width:343px">Apply filters</button>
            </div>
        </div>
       
    </form>
